module.exports = __webpack_public_path__ + "img/mockamole.775ec4fb.jpg";